module.exports = __webpack_public_path__ + "static/media/21ECLAC24.d08640b6.jpg";